import { render, staticRenderFns } from "./OrdersChart.vue?vue&type=template&id=0d4de3a2&"
import script from "./OrdersChart.vue?vue&type=script&lang=js&"
export * from "./OrdersChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports